import axios from 'axios';
import {TOKEN_KEY, UNAUTHORIZED_HTTP_CODE, USER_KEY} from "../../constants/common";
import {logger} from "./log-api";

var instance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST + '/api/',
});

if (localStorage.getItem(TOKEN_KEY)) {
  // Alter defaults after instance has been created
  instance.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(TOKEN_KEY);
}

// Add a 401 response interceptor
instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
    if (error.response!=null && error.response.status === UNAUTHORIZED_HTTP_CODE) {
    instance.defaults.headers.common['Authorization'] = '';
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    if (window.location.pathname !== '/login') {      
      window.location = '/login';
    }
  } else {
    //logger.error("axios promise error", error);
    return Promise.reject(error);
  }
});

export default instance;